import React from 'react'

const PlantShape = ({ cover, rotation, position,args }) => {
  return (
    <mesh
      receiveShadow
      rotation={rotation ? rotation : [-Math.PI / 1.9, 0, 0]}
      position={position}
    >
      <planeGeometry attach='geometry' args={args?args:[50, 50]} />
      <meshStandardMaterial map={cover} attach='material' />
    </mesh>
  )
}

export default PlantShape
